const screen = shallowRef(null);
const shapeTop = shallowRef(null);
const shapeBottom = shallowRef(null);

export function usePageLoader() {
    return {
        screen,
        shapeTop,
        shapeBottom
    };
}
